import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  static required(fieldName: string = 'This field'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isValid = control.value !== null && 
                      control.value !== undefined && 
                      control.value !== '';
      
      return !isValid ? { 
        required: true,
        message: `${fieldName} is required`
      } : null;
    };
  }
  static email(fieldName: string = 'Email'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      const isValid = emailPattern.test(control.value);
      return !isValid ? { 
        email: true,
        message: `Please enter a valid ${fieldName.toLowerCase()} address`
      } : null;
    };
  }
  static brandKey(fieldName: string = 'Brand key'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
  
      const brandKeyPattern = /^[a-z0-9]([a-z0-9_]*[a-z0-9])?$/;
      const isValid = brandKeyPattern.test(control.value);
  
      return !isValid ? {
        brandKey: true,
        message: `${fieldName} must contain only lowercase letters, numbers, and underscores. No leading or trailing underscores.`
      } : null;
    };
  }
  static minMaxElements(min: number, max: number = Infinity): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!Array.isArray(value)) {
        return { notArray: true };
      }
      const length = value.length;
      if (length < min) {
        return { minArrayLength: { requiredMin: min, actual: length } };
      }
      if (length > max) {
        return { maxArrayLength: { requiredMax: max, actual: length } };
      }
      return null;
    };
  }
  static numericOnly(fieldName: string = 'This field'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;
      const isValid = /^\d+$/.test(control.value);
      return isValid ? null : {
        numericOnly: true,
        message: `${fieldName} must contain numbers only`
      };
    };
  }
  static url(fieldName: string = 'URL'): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value: string = control.value?.trim();
      if (!value) return null;

      const urlPattern = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?(\?[^\s]*)?(#[^\s]*)?$/;
      const isValid = urlPattern.test(value);

      return isValid ? null : { message: `${fieldName} is invalid` };
    };
  }
}